<template>
  <div class="members-form-main">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8 col-md-10 col-sm-12">
          <div class="card card-top-line my-4">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <h4 class="mt-2">Upload document</h4>
                <img
                  src="@/assets/payangel_logo.png"
                  class="img-fluid"
                  width="170"
                />
              </div>
            </div>
          </div>
          <div class="card card-top-line mb-0 form-field">
            <div class="card-body">
              <form @submit.prevent="submitForm" ref="form" v-if="!submited">
                <div class="form-group">
                  <span class="float-label">
                    <div class="custom-file">
                      <input
                        type="file"
                        class="custom-file-input"
                        id="inputGroupFile01"
                        @change="upload"
                      />
                      <label class="custom-file-label" for="inputGroupFile01">
                        Upload Passport
                      </label>
                    </div>
                    <div class="ml-2">
                      {{ document.name }}
                    </div>
                  </span>
                </div>
                <div class="img-or-selfie mb-3">
                  <!-- Selfie Upload-->
                  <div class="selfie-area">
                    <div class="form-group plus-sign upload-Photograph-box">
                      <div class="custom-file" v-if="takeSelfie">
                        <label class="custom-file-label py-5" for="takeSelfie">
                          <input
                            type="file"
                            id="takeSelfie"
                            ref="takeSelfie"
                            class="form-control custom-file-input"
                            placeholder=""
                            accept="image/*"
                          />
                          <div class="img-uploaded">
                            <img class="img-fluid" :src="takeSelfie" />
                          </div>
                        </label>
                      </div>
                      <div
                        v-if="isCameraOpen && !takeSelfie"
                        v-show="!isLoading"
                        class="capture-selfie camera-button d-flex align-items-center justify-content-center"
                        :class="{ flash: isShotPhoto }"
                      >
                        <div
                          class="camera-shutter"
                          :class="{ flash: isShotPhoto }"
                        ></div>
                        <video
                          style="width: 100%; height: 100%"
                          v-show="!isPhotoTaken"
                          ref="camera"
                          autoplay
                        ></video>
                        <canvas
                          :width="600"
                          :height="450"
                          v-show="isPhotoTaken"
                          id="photoTaken"
                          ref="canvas"
                        ></canvas>
                      </div>
                      <button
                        type="button"
                        class="btn btn-outline-primary mb-2"
                        v-if="isCameraOpen"
                        @click="toggleCamera"
                      >
                        Close Camera
                      </button>
                      <div
                        class="capture-selfie"
                        v-if="!takeSelfie && !isCameraOpen"
                      >
                        <div
                          class="camera-button custom-file-label py-5"
                          :class="{
                            '': !isCameraOpen,
                            'border-danger py-3': isCameraOpen,
                          }"
                          @click="toggleCamera"
                        >
                          <p class="mb-0 d-flex flex-column">
                            <i class="fa fa-camera fa-2x"></i>
                            <span v-if="!isCameraOpen">Take a Selfie</span>
                            <!-- <span v-else class="text-danger"> Close Camera </span> -->
                          </p>
                        </div>
                        <!-- <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash' : isShotPhoto }">
                                                    <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>
                                                    <video :width="150" :height="112.5" v-show="!isPhotoTaken" ref="camera" autoplay></video>
                                                    <canvas :width="600" :height="450" v-show="isPhotoTaken" id="photoTaken" ref="canvas"></canvas>
                                                </div> -->
                      </div>
                      <div
                        v-if="!takeSelfie && isCameraOpen && !isLoading"
                        class="camera-shoot"
                      >
                        <button
                          type="button"
                          class="btn btn-primary btn-mw btn-lg"
                          @click="takePhoto"
                        >
                          <i class="fa fa-camera"></i>
                          Capture Photograph
                        </button>
                      </div>
                      <div class="camera-shoot mt-3" v-if="takeSelfie">
                        <button
                          type="button"
                          class="btn btn-outline-primary btn-mw btn-lg"
                          @click="removeSelfieUploadPhoto"
                        >
                          Retake Selfie
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex flex-column flex-md-row justify-content-center"
                >
                  <b-button
                    type="submit"
                    variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                    size="lg"
                  >
                    Submit
                  </b-button>
                </div>
              </form>
              <div class="text-center" v-else>
                <h4>You have Submited Document</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { myFunction } from "@/common/common-helper.js";
export default {
  name: "GenerateDocumentUploadLink",
  components: {},
  methods: {
    submitForm() {
      if (this.document) {
        console.log(this.document);
        myFunction.showInfo("Document Uploaded Successfully", "success");
        this.submited = true;
      } else {
        myFunction.showInfo("Please Upload Document", "error");
      }
    },
    upload(e) {
      if (e.target.files.length > 0) {
        let file = e.target.files[0];
        this.document = file;
      }
    },

    toggleCamera() {
      if (this.isCameraOpen) {
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.stopCameraStream();
      } else {
        this.isCameraOpen = true;
        this.createCameraElement();
      }
    },

    createCameraElement() {
      this.isLoading = true;
      const constraints = (window.constraints = {
        audio: false,
        video: true,
      });

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.isLoading = false;
          this.$refs.camera.srcObject = stream;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
          this.isCameraOpen = false;
          myFunction.showInfo(
            "Use webcam OR mobile phone to verify your identity",
            "error",
          );
        });
    },

    stopCameraStream() {
      if (this.$refs.camera.srcObject) {
        let tracks = this.$refs.camera.srcObject.getTracks();
        tracks.forEach((track) => {
          track.stop();
        });
      }
    },

    //using webcam uplaod image
    takePhoto() {
      if (!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }

      this.isPhotoTaken = !this.isPhotoTaken;

      const context = this.$refs.canvas.getContext("2d");
      context.drawImage(this.$refs.camera, 0, 0, 600, 450);

      const canvas = document.getElementById("photoTaken");
      this.isPhotoTaken = false;
      const selfieFile = this.dataURLtoBlob(canvas.toDataURL());
      this.document = selfieFile;
      this.takeSelfie = URL.createObjectURL(selfieFile);
      this.stopCameraStream();
      this.isCameraOpen = false;
      if (selfieFile) {
        myFunction.showInfo("Photo Captured Successfully", "success");
      }
    },

    dataURLtoBlob(dataURL) {
      let array, binary, i, len;
      binary = atob(dataURL.split(",")[1]);
      array = [];
      i = 0;
      len = binary.length;
      while (i < len) {
        array.push(binary.charCodeAt(i));
        i++;
      }
      return new Blob([new Uint8Array(array)], {
        type: "file",
      });
    },

    removeSelfieUploadPhoto() {
      this.$refs.takeSelfie.value = null;
      this.takeSelfie = null;
      this.isCameraOpen = false;
    },
  },
  beforeDestroy() {
    this.stopCameraStream();
  },
  data() {
    return {
      document: "",
      submited: false,
      takeSelfie: null,

      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading: false,
    };
  },
  mounted() {
    //
  },
};
</script>
